// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__1o-YD","name":"styles_name__ESZ8N","dot":"styles_dot__1mdO9","targetStatus":"styles_targetStatus__2AixZ"};